import axios from 'axios';
import { getApiBaseUrl } from '../config/apiBase';

const baseURL = getApiBaseUrl();

const api = axios.create({
  baseURL,
});

/** No auth interceptors — used only for token refresh to avoid recursion. */
const rawApi = axios.create({
  baseURL,
});

let refreshPromise = null;

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token');
  }
  const { data } = await rawApi.post('auth/refresh', { refreshToken });
  localStorage.setItem('userToken', data.accessToken);
  if (data.refreshToken) {
    localStorage.setItem('refreshToken', data.refreshToken);
  }
  localStorage.setItem('userData', JSON.stringify(data));
  localStorage.setItem('dp', JSON.stringify(data.displayPicture));
  localStorage.setItem('email', JSON.stringify(data.email));
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('userToken');
  config.headers = config.headers || {};
  config.headers['x-access-token'] = token;
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  } else if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const res = error.response;
    const original = error.config;
    if (!res || !original) {
      return Promise.reject(error);
    }
    const url = (original.url || '').toString();
    if (
      url.includes('auth/refresh') ||
      url.includes('auth/signin') ||
      url.includes('auth/google') ||
      url.includes('auth/check-signup-availability')
    ) {
      return Promise.reject(error);
    }
    const code = res.data && res.data.code;
    if (res.status === 401 && code === 'ACCESS_TOKEN_EXPIRED' && !original.__isRetry) {
      original.__isRetry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = refreshAccessToken().finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(original);
      } catch (e) {
        localStorage.clear();
        if (typeof window !== 'undefined') {
          window.location.assign('/sign-in');
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
